module.exports = __webpack_public_path__ + "static/img/5g1.3a05219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5g1.png
// module id = fSeV
// module chunks = 21